const PRODUCTS = {
  PRODUCTS: '/products',
  PRODUCT_CREATE: '/product/create',
  PRODUCT_DELETE: '/product/delete/:identifier',
  PRODUCT_EDIT: '/product/delete/:identifier'
} as const

export default PRODUCTS
